import React from "react";

const MicrosoftExcelGreenIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.79036 7.67495L4.25586 6.69995V13.9045C4.25593 13.9827 4.27141 14.0602 4.30142 14.1325C4.33143 14.2048 4.37539 14.2704 4.43078 14.3257C4.48617 14.381 4.55191 14.4249 4.62424 14.4548C4.69658 14.4847 4.77409 14.5 4.85236 14.5H14.4024C14.4807 14.5001 14.5583 14.4849 14.6308 14.4551C14.7032 14.4252 14.7691 14.3814 14.8246 14.3261C14.8801 14.2708 14.9241 14.2051 14.9542 14.1327C14.9843 14.0604 14.9998 13.9828 14.9999 13.9045V11.25L9.79036 7.67495Z"
      fill="#185C37"
    />
    <path
      d="M9.79036 1.5H4.85236C4.77409 1.49993 4.69658 1.51529 4.62424 1.54518C4.55191 1.57507 4.48617 1.61891 4.43078 1.67421C4.37539 1.72951 4.33143 1.79517 4.30142 1.86746C4.27141 1.93974 4.25593 2.01723 4.25586 2.0955V4.75L9.79036 8L12.7209 8.975L14.9999 8V4.75L9.79036 1.5Z"
      fill="#21A366"
    />
    <path d="M4.25586 4.75H9.79036V8H4.25586V4.75Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M8.21686 4.1001H4.25586V12.2251H8.21686C8.37469 12.2243 8.52586 12.1614 8.63761 12.0499C8.74935 11.9384 8.81268 11.7874 8.81386 11.6296V4.6956C8.81268 4.53777 8.74935 4.38676 8.63761 4.27529C8.52586 4.16383 8.37469 4.10088 8.21686 4.1001Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.89136 4.42505H4.25586V12.55H7.89136C8.04919 12.5493 8.20036 12.4863 8.31211 12.3749C8.42385 12.2634 8.48718 12.1124 8.48836 11.9545V5.02055C8.48718 4.86272 8.42385 4.71171 8.31211 4.60024C8.20036 4.48878 8.04919 4.42583 7.89136 4.42505Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.89136 4.42505H4.25586V11.9H7.89136C8.04919 11.8993 8.20036 11.8363 8.31211 11.7249C8.42385 11.6134 8.48718 11.4624 8.48836 11.3045V5.02055C8.48718 4.86272 8.42385 4.71171 8.31211 4.60024C8.20036 4.48878 8.04919 4.42583 7.89136 4.42505Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M7.56586 4.42505H4.25586V11.9H7.56586C7.72369 11.8993 7.87486 11.8363 7.98661 11.7249C8.09835 11.6134 8.16168 11.4624 8.16286 11.3045V5.02055C8.16168 4.86272 8.09835 4.71171 7.98661 4.60024C7.87486 4.48878 7.72369 4.42583 7.56586 4.42505Z"
      fill="black"
    />
    <path
      d="M1.597 4.42505H7.566C7.72411 4.42492 7.87581 4.48757 7.98776 4.59923C8.0997 4.71089 8.16273 4.86243 8.163 5.02055V10.9795C8.16273 11.1377 8.0997 11.2892 7.98776 11.4009C7.87581 11.5125 7.72411 11.5752 7.566 11.575H1.597C1.51869 11.5752 1.44112 11.5599 1.36873 11.53C1.29634 11.5002 1.23054 11.4563 1.17509 11.401C1.11965 11.3457 1.07565 11.28 1.04561 11.2077C1.01556 11.1354 1.00007 11.0579 1 10.9795V5.02055C1.00007 4.94224 1.01556 4.86471 1.04561 4.79239C1.07565 4.72008 1.11965 4.65439 1.17509 4.59908C1.23054 4.54378 1.29634 4.49994 1.36873 4.47008C1.44112 4.44022 1.51869 4.42492 1.597 4.42505Z"
      fill="url(#paint0_linear_2_2922)"
    />
    <path
      d="M2.8501 9.93648L4.1056 7.99448L2.9556 6.06348H3.8791L4.5066 7.29998C4.5646 7.41698 4.6066 7.50398 4.6256 7.56198H4.6341C4.6751 7.46798 4.7186 7.37748 4.7641 7.28898L5.4351 6.06548H6.2851L5.1056 7.98548L6.3151 9.93798H5.4106L4.6856 8.58248C4.65193 8.5242 4.62333 8.46314 4.6001 8.39998H4.5881C4.56696 8.46152 4.53877 8.52041 4.5041 8.57548L3.7576 9.93648H2.8501Z"
      fill="white"
    />
    <path
      d="M14.403 1.5H9.79053V4.75H15V2.0955C15 2.01719 14.9845 1.93966 14.9544 1.86734C14.9244 1.79503 14.8804 1.72934 14.8249 1.67403C14.7695 1.61873 14.7037 1.5749 14.6313 1.54503C14.5589 1.51517 14.4813 1.49987 14.403 1.5Z"
      fill="#33C481"
    />
    <path d="M9.79053 8H15V11.25H9.79053V8Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_2_2922"
        x1="2.247"
        y1="3.95705"
        x2="6.916"
        y2="12.043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
);

export default MicrosoftExcelGreenIcon;
